import React from 'react';

// Modifiers
import addEmoji from '../modifiers/addEmoji';

// Types
import { EmojiData, EmojiPluginStore } from '../emojiPlugin';

// Components
import { EmojiPicker } from 'Shared/components/EmojiMartComponents';
import EmojiMartDropdownPopover from './EmojiMartDropdownPopover';
import { Portal } from '../../../../portal/Portal';
import WpBackdrop from '../../../../backdrop/WpBackdrop';

export interface EmojiMartDropdownPubProps {
  open?: boolean;
  onOpenChange?(open: boolean): void;
  emojiMartDropdownRef: React.Ref<HTMLDivElement>;
}

export interface EmojiMartDropdownProps extends EmojiMartDropdownPubProps {
  store: EmojiPluginStore;
}

const EmojiMartDropdown = ({ open, onOpenChange, emojiMartDropdownRef, store }: EmojiMartDropdownProps) => {
  if (!open) return null;
  const handleEmojiClick = (emoji: EmojiData) => {
    const newEditorState = addEmoji(store.getEditorState!(), emoji);
    store.setEditorState!(newEditorState);
    onOpenChange(false);
  };

  const handleDismissOnBackdrop = () => {
    onOpenChange(false);
  };

  return (
    <Portal idPrefix="EmojiMartDropdown">
      <EmojiMartDropdownPopover emojiMartDropdownRef={emojiMartDropdownRef}>
        <div onClick={e => e.stopPropagation()}>
          <EmojiPicker onSelect={handleEmojiClick} title="Pick your emoji…" emoji="point_up" />
        </div>
      </EmojiMartDropdownPopover>
      <WpBackdrop onClick={handleDismissOnBackdrop} transparent />
    </Portal>
  );
};

export default EmojiMartDropdown;
